import { config } from '../app-configuration/config.js';

/**
 * Get the firebase config for an app.
 * @param {string} appId - The app ID (project ID) to get the firebase config for.
 */
export function FirebaseConfig(appId) {
  const { firebaseConfigs } = config;
  const firebaseConfig = firebaseConfigs[appId];
  return firebaseConfig
    ? {
        apiKey: firebaseConfig.apiKey,
        authDomain: firebaseConfig.authDomain,
        projectId: firebaseConfig.projectId,
        databaseURL: firebaseConfig.databaseURL,
        storageBucket: firebaseConfig.storageBucket,
        messagingSenderId: firebaseConfig.messagingSenderId,
        appId: firebaseConfig.appId,
        isPortalServer: firebaseConfig.isPortalServer
      }
    : {};
}

/**
 * Get the list of projects.
 * @returns {string[]} The list of projects.
 */
export function getProjectList() {
  return Object.keys(config.firebaseConfigs);
}

/**
 * Get the server names from the config.
 * @returns {Record<string, string>} The server names.
 */
export function getServerNames() {
  return config.serverNames ?? {};
}
